/**
 * Escape HTML special characters
 */
export function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

/**
 * Resolve template variables in telegram message text
 */
export function resolveTelegramMessageText(text, profile, currentPrompt) {
  const prompt = currentPrompt || profile?.defaultRequest || '把最新进展同步一下'
  return String(text || '').replace(/\{\{query\}\}/g, prompt)
}

/**
 * Normalize demo query
 */
export function normalizeDemoQuery(raw) {
  return String(raw || '').trim() || '自主Agent有哪些？'
}

/**
 * Shorten demo query for display
 */
export function shortenDemoQuery(query, maxLen) {
  if (!query) return ''
  const clean = query.replace(/[？?！!。，,；;：:、]/g, ' ').trim()
  if (clean.length <= maxLen) return clean
  return clean.slice(0, maxLen) + '…'
}

/**
 * Extract topic from query
 */
export function extractDemoTopic(query) {
  const match = query.match(/[\u4e00-\u9fa5A-Za-z]+Agent|[\u4e00-\u9fa5A-Za-z]+框架|[\u4e00-\u9fa5A-Za-z]+工具/)
  if (match) return match[0]
  const words = query.replace(/[？?！!。，,；;：:、]/g, ' ').trim().split(/\s+/)
  return words[0] || query.slice(0, 8)
}

/**
 * Generate group avatar HTML labels
 */
export function createGroupAvatarHtml(labels) {
  if (!labels || !labels.length) return ''
  const nodes = labels.slice(0, 3)
  const classes = ['a', 'b', 'c']
  return nodes.map((label, i) =>
    `<span class="group-node ${classes[i] || ''}">${escapeHtml(label)}</span>`
  ).join('')
}

/**
 * Encode payload for data attributes
 */
export function escapeTelegramPayload(payload) {
  return encodeURIComponent(JSON.stringify(payload || {}))
}

/**
 * Decode payload from data attributes
 */
export function readTelegramPayload(value) {
  if (!value) return null
  try {
    return JSON.parse(decodeURIComponent(value))
  } catch {
    return null
  }
}

/**
 * Clamp a value between min and max
 */
export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

/**
 * Format report filename from query
 */
export function makeReportFileName(query, isAutonomous) {
  if (isAutonomous) return 'Autonomous_Agents_Report.md'
  const reportQuery = shortenDemoQuery(normalizeDemoQuery(query), 20)
  return `${reportQuery.replace(/[\\/:*?"<>|\s]+/g, '_') || 'Research'}_Report.md`
}

/**
 * Restore localStorage value with fallback
 */
export function getStorageItem(key, fallback = null) {
  try {
    const value = localStorage.getItem(key)
    return value !== null ? value : fallback
  } catch {
    return fallback
  }
}

export function setStorageItem(key, value) {
  try {
    localStorage.setItem(key, String(value))
  } catch {
    // ignore
  }
}
